import { DialogBase } from '@scale/dialog-base';
import { Events, DrawerOpenEvent, DrawerCloseEvent, ToastEvent } from '@scale/events';
import { morphSection } from '@scale/section-renderer';

class ScaleCartDrawer extends DialogBase {
  static observeRefs = true;

  get useHistory() {
    return true;
  }

  get dialogId() {
    return 'cart-drawer';
  }

  setupDialog() {
    this.onDocument(Events.CART_UPDATED, (e) => this.#onCartUpdated(e));
    this.onDocument(Events.CART_ERROR, (e) => this.#onCartError(e));
  }

  updatedCallback() {
    this.invalidateRefs();
  }

  onDialogOpen() {
    this.broadcast(new DrawerOpenEvent('cart-drawer'));
  }

  onDialogClose() {
    this.broadcast(new DrawerCloseEvent('cart-drawer'));
  }

  #onCartUpdated(event) {
    const { source } = event;
    const sectionId = this.dataset.sectionId;
    const html = event.cart?.sections?.[sectionId];

    if (html) morphSection(sectionId, html);

    if (source === 'add') {
      this.broadcast(new ToastEvent(Scale.translations.addedToCart, { type: 'success' }));
      if (this.dataset.openOnAdd === 'true' && this.dataset.cartIconBehavior !== 'page') {
        queueMicrotask(() => this.open());
      }
    }
  }

  #onCartError(event) {
    this.broadcast(new ToastEvent(event.error?.message || 'Error', { type: 'error' }));
  }
}

if (!customElements.get('scale-cart-drawer')) {
  customElements.define('scale-cart-drawer', ScaleCartDrawer);
}
